import React from 'react';
import { twMerge } from 'tailwind-merge';

export const baseClasses =
  'flex duration-300 items-center text-xs sm:text-base gap-1 md:gap-2 uppercase px-2 py-1.5 md:px-6 md:py-3';

const Button = ({ onClick, children, variant, type, formId, className, disabled }) => {
  const variantClasses = (() => {
    switch (variant) {
      case 'primary':
        return 'bg-gradient-to-r from-contrast2 to-contrast1 text-font1 hover:bg-gradient-to-l';
      case 'secondary':
        return 'ring-1 ring-bg5 hover:ring-2 hover:ring-opacity-70';
      case 'secondary2':
        return 'md:ring-1 md:ring-bg5 px-0 py-0 md:px-2 md:py-2 hover:ring-2 hover:ring-opacity-70';
      case 'danger':
        return 'bg-gradient-to-r from-bg4 to-bg1 hover:bg-gradient-to-l text-font1';
      case 'download':
        return 'px-1 py-1 md:px-2 md:py-2';
      case 'action':
        return 'text-bg1 hover:text-contrast2';
      case 'action2':
        return 'border border-bg5 hover:bg-bg4 p-1.5 md:p-3 hover:text-font1';
      case 'toolbar':
        return 'bg-white hover:bg-gray-100 border';
      default:
        return '';
    }
  })();

  if (type === 'submit') {
    return (
      <button
        type="submit"
        form={formId}
        disabled={disabled}
        className={twMerge(baseClasses, variantClasses, className)}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={twMerge(baseClasses, variantClasses, className)}
    >
      {children}
    </button>
  );
};

export default Button;
